import { useEffect, useState } from "react";

const useIsCompactView = () => {
  const [isCompactView, setIsCompactView] = useState(false);

  const handleWindowSizeChange = () => {
    const isCompactView = window.innerWidth < 1040; // Set your threshold here
    setIsCompactView(isCompactView);
  };

  useEffect(() => {
    // Initial check on component mount
    handleWindowSizeChange();

    // Add event listener to update on window resize
    window.addEventListener("resize", handleWindowSizeChange);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return isCompactView;
};

export default useIsCompactView;
